<template>
  <div class="play-container" v-if="isLoaded" :style="{'z-index':zIndex}">
    <Header>
      <div class="header-top">
        <main-header></main-header>
      </div>
    </Header>
    <lnb-wrapper></lnb-wrapper>
    <portal-target name="info-popup" data-scroll-element="true"></portal-target>
    <div class="play-detail-container">
      <div class="player" id="player" @click.prevent="clickCont" @touchstart="clickCont">
        <div v-show="isVodPlaying == false">
          <img :src="'https://' + contentInfo.image" :alt="contentInfo.title" :class="'player-image ' + currentSection">
          <div @click.prevent="clickPlayer" class="btn-play"><player class="play-btn"></player></div>
          <div @click.prevent="goBack()" class="player-back-btn">
            <span class="a11y-hidden">뒤로 가기</span>
            <BackButton/>
          </div>
        </div>
        <VodPlayerUI @on-load="setVodPlayerUI" v-if="vodObject != null" v-show="isVodPlaying && isShowVodControl && isShowPlayEndRecommend === false && isShowPlayEndGuide === false" :vod-object="vodObject"></VodPlayerUI>
        <AdvertisementUI @on-load="setAdvertisementUI" v-if="vodObject != null && vodObject.isAd" v-show="isVodPlaying" :vod-object="vodObject"></AdvertisementUI>
        <img v-if="isVodPlaying == true && streamingInfo.quality == '100p'" :src="'https://' + contentInfo.image" :alt="contentInfo.title" :class="'player-image ' + currentSection">
        <div v-if="isVodPlaying == true && streamingInfo.quality == '100p'" class="audio"><img src="../../assets/images/ic_player_audio.png">오디오 모드 입니다.</div>
      </div>
      <PlayEndPlayList v-show="isShowPlayEndPlayList" :streaming-info="streamingInfo" :content-info="contentInfo" :play-end-play-list-status="playEndPlayListStatus" :exit-play-end-play-list-popup="exitPlayEndPlayListPopup"></PlayEndPlayList>
      <PlayEndRecommend @go-bottom-recommend-tab="goBottomRecommendTab" v-show="isShowPlayEndRecommend" :close-play-end-recommend-popup="closePlayEndRecommendPopup"></PlayEndRecommend>
      <PlayEndGuide v-show="isShowPlayEndGuide" :streaming-info="streamingInfo.preview" :is-vod-playing="isVodPlaying" :close-play-end-guide-popup="closePlayEndGuidePopup" :content-info="contentInfo" :content-type="getContentType(contentInfo)" :content-id="getContentId(contentInfo)" :program-id="getProgramId()"></PlayEndGuide>
      <LoginGuide v-if="!getCredential && isRadioChannel() === false" :streaming-info="streamingInfo.preview"></LoginGuide>
      <PurchaseGuide v-if="getCredential && vodObject != null && vodObject.purchaseMsg != null" :msg="vodObject.purchaseMsg" :btns="vodObject.purchaseBtns" :content-info="contentInfo" :content-type="getContentType(contentInfo)" :content-id="getContentId(contentInfo)" :program-id="getProgramId()"></PurchaseGuide>
      <QualitySelect @on-load="setQualitySelect" v-if="streamingInfo != null && streamingInfo.qualities != null" v-show="isOpenSetting" :quality-list="streamingInfo.qualities.list" :curr-quality="streamingInfo.quality"></QualitySelect>
      <HomeShoppingOrder v-show="isHomeShoppingChannel && snsPopupStatus === false && isOpenSetting == false" :home-shopping-ch-info="homeShoppingChInfo"></HomeShoppingOrder>
      <component v-if="!isLoading" :is="playerDetailComponent"
                 :content-info="contentInfo"
                 :get-toggle-button="getToggleButton"
                 :toggle-info="toggleDetailInfo"
                 :tag-list="getConvertedTagList"
                 :click-tag="clickTag"
                 :toggle-state="detailInfoToggleState"
      ></component>
      <a href="#" @click.prevent="()=>goLiveChannel(contentInfo.livechannel)" class="live-channel" v-if="currentSection === 'vod' &&contentInfo.livechannel !== ''">
        <span>전용 LIVE채널</span>
        <NextButtonWhite/>
      </a>
      <div class="detail-view-more" v-if="detailInfoToggleState">
        <component @on-control="controlMoreInfo" :is="descInfoMoreComponent" :content-info="contentInfo"></component>
      </div>

      <div v-if="eventList.length > 0">
        <div class="play-event-container" v-for="(event, index) in eventList" :key="'movie_event' + index">
          <div class="event-header" @click.prevent="toggleEventInfo(index)">
            <span class="tag tag-event">이벤트</span>
            <span class="title">{{event.eventtitle}}</span>
            <span class="icon-btn"><EventClose v-if="eventToggleState" /><EventOpen v-else/></span>
          </div>
          <div class="event-body" v-if="EventToggle(index)">
            <span class="gift">{{event.gift}}</span>
            <span class="event-box">
              <span class="event-date-txt">기간</span>
              <span class="event-date">{{getMonthDayString(event.startdate)}} - {{getMonthDayString(event.enddate)}}</span>
            </span>
            <span class="event-box" v-if="event.announcementdate">
              <span class="event-date-txt">당첨자 발표일</span>
              <span class="event-date">{{getMonthDayString(event.announcementdate)}} ({{getDayOfWeek(event.announcementdate)}})</span>
            </span>
            <a href="#" class="event-link" @click.prevent="()=>goEventPage(event)">
              <span>이벤트 페이지로 이동</span>
              <NextButtonWhite/>
            </a>
          </div>
        </div>
      </div>
    </div>
    <Meta :content-info="contentInfo" />
    <BottomTabContainer v-if="isBottomLoad" :content-info="contentInfo" :key="$route.fullPath" :is-home-shopping-channel="isHomeShoppingChannel"/>
    <Oval :is-home-shopping-channel="isHomeShoppingChannel"/>
  </div>
</template>

<script>
import MainHeader from '@/components/header/template/MainHeader'
import axios from 'axios'
import GNB from '@/common/GNB'
import { ClipInfoService, LiveInfoService, MovieInfoService, VodInfoService, StreamingService } from '@/common/api/api.service'
import { topTagList } from '@/common/directives'
import { findIndex, get, remove } from 'lodash'
import { mapGetters, mapMutations } from 'vuex'
import CellList from '@/components/section/template/cell/CellList'
import AllContentList from '@/components/play/bottom-tab/AllContentList'
import BottomTabContainer from '@/components/play/bottom-tab/BottomTabContainer'
import EventOpen from '@/assets/svg/common/ic_open_b.svg'
import EventClose from '@/assets/svg/common/ic_closd_b.svg'
import { enableBodyScroll, disableBodyScroll } from '@/common/util/ui.utils'
import Player from '@/assets/svg/common/ic-player-play-l.svg'
import utils from '@/common/util/utils'
import NextButtonWhite from '@/assets/svg/common/ic-next-s-w.svg'
import BackButton from '@/assets/svg/common/ic_gnb_back_w.svg'
import Oval from '@/components/Oval'
import { NEED_LOGIN, NEED_VERIFIED, URL_COOKIE_DOMAIN, MSG_PLAYVOD_CONTINUED } from '@/common/constant'
import { EventBus } from '@/components/eventbus/EventBus'
import LnbWrapper from '@/components/lnb/LnbWrapper'
import Meta from '@/components/meta/Meta'
import VodPlayer from '@/common/vodutil/vodplayer'
import VodObject from '@/common/vodutil/vodobject'
import LoginGuide from '@/components/play/LoginGuide'
import VodPlayerUI from '@/components/play/VodPlayerUI'
import AdvertisementUI from '@/components/play/AdvertisementUI'
import PurchaseGuide from '@/components/play/PurchaseGuide'
import PlayEndGuide from '@/components/play/PlayEndGuide'
import QualitySelect from '@/components/play/QualitySelect'
import PlayEndPlayList from '../../components/play/PlayEndPlayList'
import PlayEndRecommend from '../../components/play/PlayEndRecommend'
import HomeShoppingOrder from '../../components/play/HomeShoppingOrder'
import { parseUrl, stringify } from 'query-string'

export default {
  name: 'PlayerDetail',
  components: {
    HomeShoppingOrder,
    LnbWrapper,
    MainHeader,
    BottomTabContainer,
    AllContentList,
    CellList,
    MoviePlayerDetailInfo: () => import('@/components/play/MoviePlayerDetailInfo'),
    MovieDescInfoMore: () => import('@/components/play/MovieDescInfoMore'),
    VodPlayerDetailInfo: () => import('@/components/play/VodPlayerDetailInfo'),
    VodDescInfoMore: () => import('@/components/play/VodDescInfoMore'),
    LivePlayerDetailInfo: () => import('@/components/play/LivePlayerDetailInfo'),
    ClipPlayerDetailInfo: () => import('@/components/play/ClipPlayerDetailInfo'),
    ClipDescInfoMore: () => import('@/components/play/ClipDescInfoMore'),
    EventOpen,
    EventClose,
    Player,
    NextButtonWhite,
    BackButton,
    Meta,
    Oval,
    LoginGuide,
    VodPlayerUI,
    AdvertisementUI,
    PurchaseGuide,
    PlayEndGuide,
    QualitySelect,
    PlayEndPlayList,
    PlayEndRecommend
  },
  directives: {
    topTagList
  },
  data () {
    return {
      isLoaded: false,
      detailInfoToggleState: false,
      eventToggleState: false,
      toggleState: 'open-info-button',
      contentInfo: {},
      streamingInfo: {},
      count: 0,
      thumbnailInfo: {},
      eventList: [],
      zIndex: 3000,
      currentSection: '',
      isLoading: false,
      isBottomLoad: true,
      eventIndexArr: [],
      isVodPlaying: false,
      isShowVodControl: false,
      isShowPlayEndGuide: false,
      vodObject: null,
      isOpenSetting: false,
      livePlayTime: 0,
      isShowPlayEndPlayList: false,
      playEndPlayListStatus: '',
      isShowPlayEndRecommend: false,
      isHomeShoppingChannel: false,
      homeShoppingChInfo: {},
      streamingStatus: '',
      isAutoPlay: false,
      snsPopupStatus: false
    }
  },
  methods: {
    ...mapMutations(['setTagSearchKeywordList', 'showSearch', 'setPrevTagTab', 'setTagSearchFilterIndex', 'showAdultCheck',
      'hideAdultCheck', 'hideEmptySearchKeyword', 'setExternalInputSearchKeyword', 'hideSearchResult', 'changeTagTab']),

    goBack () {
      if (get(this.$route, ['query', 'referer'], '').indexOf('mypooq') > -1) {
        const GLOBAL_VOD_GENRE_CODE = '09'
        const section = get(this.$route, ['params', 'section'], '')
        const isVod = section === 'vod'
        const isGlobalVod = get(this.contentInfo, 'genrevalue', '') === GLOBAL_VOD_GENRE_CODE
        if (isVod) {
          if (isGlobalVod) {
            this.$router.push({ name: 'global' })
          } else {
            this.$router.push({ name: 'vod' })
          }
        } else {
          this.$router.push({ name: this.$route.params.section })
        }
      } else {
        this.$router.back()
      }
    },
    getMonthDayString (yearMonthDay) {
      const arr = yearMonthDay.split('-')
      arr[1] = arr[1].charAt(0) === '0' ? arr[1].substr(1, 1) : arr[1]
      arr[2] = arr[2].charAt(0) === '0' ? arr[2].substr(1, 1) : arr[2]
      return `${arr[1]}월 ${arr[2]}일`
    },
    getDayOfWeek (yearMonthDay) {
      let week = ['일', '월', '화', '수', '목', '금', '토']
      return week[new Date(yearMonthDay).getDay()]
    },
    toggleDetailInfo () {
      this.detailInfoToggleState = !this.detailInfoToggleState
    },
    toggleEventInfo (index) {
      if (this.eventIndexArr.indexOf(index) > -1) {
        this.eventIndexArr = remove(this.eventIndexArr, function (n) {
          return n !== index
        })
      } else {
        this.eventIndexArr.push(index)
      }
    },
    clickTag (tag) {
      let tagList = []
      if (this.currentSection === 'clip') {
        get(this.contentInfo, ['tags', 'list'], []).map((tag) => {
          if (typeof tag === 'string') {
            tagList.push({
              text: tag,
              value: tag,
              taggroup: 'tag'
            })
          }
        })
      } else {
        tagList = Object.assign([], get(this.contentInfo, ['tags', 'list'], []))
      }
      const targetIndex = findIndex(tagList, (t) => {
        return t.value === tag.value
      })
      const tabName = this.currentSection === 'movie' ? 'movie' : 'vod'

      const clickedTag = tagList.splice(targetIndex, 1)
      tagList.unshift(clickedTag[0])
      this.setPrevTagTab(tabName)// 구분을 movie 와 vod로 구분
      this.changeTagTab('all')
      this.setTagSearchFilterIndex(0)
      this.setTagSearchKeywordList(tagList)
      this.hideEmptySearchKeyword()
      this.setExternalInputSearchKeyword('')
      this.hideSearchResult()
      this.$router.push('/search')
    },
    removeEvent () {
      EventBus.$off('on-exit')
      EventBus.$off('on-enter')
    },
    verifiedAdultContent (contentInfo) {
      const targetAge = Number(get(contentInfo, 'targetage', '0'))
      const res = utils.common.verifyAdult(targetAge)
      const { query } = parseUrl(this.$route.fullPath)
      delete query.referer
      if (res === NEED_LOGIN) {
        this.$router.replace(`/login?referer=${this.$route.path}?${stringify(query)}`)
      } else if (res === NEED_VERIFIED) {
        this.isBottomLoad = false
        EventBus.$once('on-exit', (section, uiCode) => {
          this.$route.query.adult = 'y'
          this.hideAdultCheck()
          this.removeEvent()
          this.isLoading = true
          this.isLoaded = false
          this.$router.back()
        })
        EventBus.$once('on-enter', () => {
          this.isBottomLoad = true
          this.hideAdultCheck()
          this.removeEvent()
        })
        this.showAdultCheck()
      } else {
        this.isBottomLoad = true
      }
      // streaming data
      if (contentInfo !== null) {
        try {
          this.loadStreamingData(contentInfo)
        } catch (e) {
          if (e) console.log(e)
        }
      }
    },
    loadContent (route) {
      this.isHomeShoppingChannel = false
      const section = this.currentSection.toUpperCase()
      if (this.isLoading) return
      this.isLoading = true
      if (section === 'MOVIE') {
        const movieID = route.query.movieid
        MovieInfoService.getMovieMetaInfo({ movieID }, (error) => {
          alert(error.response.data.resultmessage)
          this.$router.push({
            name: 'like_movie',
            params: {
              isError: true
            }
          })
        }).then(({ data }) => {
          this.verifiedAdultContent(data)
          this.contentInfo = data
          this.isLoaded = true
          this.isLoading = false
        })
        MovieInfoService.getEventBanner({ movieID }).then(({ data }) => {
          if (data.list.length) {
            this.eventList = data.list
          } else {
            this.eventList = []
          }
        })
      } else if (section === 'VOD') {
        const programID = get(route, ['query', 'programid'], '')
        const contentID = get(route, ['query', 'contentid'], '')
        const setVodMetaInfo = (contentID) => {
          VodInfoService.getVodMetaInfo({ contentID }).then(({ data }) => {
            this.verifiedAdultContent(data)
            this.contentInfo = data
            this.isLoaded = true
            this.isLoading = false
          }).catch(() => {
            this.$router.back()
          })
        }
        if (contentID !== '') {
          setVodMetaInfo(contentID)
        } else if (programID !== '') {
          VodInfoService.getContentIdByProgramId({ programID }).then(({ data }) => {
            setVodMetaInfo(data.contentid)
          })
        }
      } else if (section === 'LIVE') {
        const channelID = route.query.channelid
        LiveInfoService.getLiveMetaInfo({ channelID }).then(({ data }) => {
          if (data.homeshopping === 'y' && data.channelid !== '') {
            let channelid = data.channelid
            StreamingService.getHomeShoppingChData({ channelid }).then(({ data }) => {
              this.homeShoppingChInfo = {}
              if (data !== null) {
                this.isHomeShoppingChannel = true
                this.homeShoppingChInfo = data
              }
              console.log('homeShoppingChInfo : ', this.homeShoppingChInfo)
            }).catch(() => {
              this.$router.back()
            })
          }
          this.verifiedAdultContent(data)
          this.contentInfo = data
          this.isLoaded = true
          this.isLoading = false
        }).catch(() => {
          this.$router.back()
        })
      } else if (section === 'CLIP') {
        const clipID = route.query.clipid
        ClipInfoService.getClipMetaInfo({ clipID }).then(({ data }) => {
          this.verifiedAdultContent(data)
          this.contentInfo = data
          this.isLoaded = true
          this.isLoading = false
        })
      } else {
        this.$router.push({ name: 'NotFound' })
      }
    },
    goLiveChannel (liveChannel) {
      this.$router.push(`/player/live?channelid=${liveChannel}`)
    },
    clickCont (e) {
      if (this.isVodPlaying === true &&this.isShowVodControl === false) {
        this.isShowVodControl = true
        this.startUITimer()
        if (e != null) e.preventDefault()
      }
    },
    clickPlayer () {
      const section = this.currentSection.toUpperCase()
      let url = ''
      switch (section) {
        case 'CLIP':
          url = 'player/clip?clipid=' + this.contentInfo.clipid
          break
        case 'MOVIE':
          url = 'player/movie?movieid=' + this.contentInfo.movieid
          break
        case 'VOD':
          url = 'player/vod?contentid=' + this.contentInfo.contentid
          break
        case 'LIVE':
          url = 'player/live?channelid=' + this.contentInfo.channelid
          break
      }

      if (utils.cookies.getItem('deviceType') === 'ssfamilyhub') {
        if (this.vodObject != null && this.vodObject.isReady) this.vodPlay()
        else {
          if (this.streamTimerId == null) {
            this.loadStreamingData(this.contentInfo)
            this.streamTimerId = setInterval(() => {
              if (this.vodObject != null && this.vodObject.isReady) {
                this.vodPlay()
                clearInterval(this.streamTimerId)
                this.streamTimerId = null
              }
            }, 200);
          }
        }
      } else utils.common.checkInstallApps(url)
    },
    isOnAirVod (contentInfo) {
      return contentInfo.type === 'onair'
    },
    getContentType (contentInfo) {
      return this.isOnAirVod(contentInfo) ? 'onairvod' : this.currentSection
    },
    getContentId (contentInfo) {
      let contentId = ''
      switch (this.currentSection.toUpperCase()) {
        case 'CLIP':
          contentId = contentInfo.clipid
          break
        case 'MOVIE':
          contentId = contentInfo.movieid
          break
        case 'VOD':
          contentId = contentInfo.contentid
          break
        case 'LIVE':
          contentId = contentInfo.channelid
          break
      }
      return contentId
    },
    makeStreamParam (contentInfo, quality) {
      let contentId = this.getContentId(contentInfo)

      const lastPlayId = utils.cookies.getItem('lastPlayId')

      return {
        'contentType': this.getContentType(contentInfo),
        'contentId': contentId,
        'action': 'hls',
        'quality': quality == null ? 'auto' : quality,
        'guid': utils.guid,
        'authType': 'url',
        'lastPlayId': lastPlayId != null ? lastPlayId : 'none',
        'isAbr': 'n', // 용도 확인필요 2.5 ver 기준으로는 familyhub 에서는 무조건 n
        'isHevc': 'n' // 용도 확인필요
      }
    },
    loadStreamingData (contentInfo) {
      let quality = utils.cookies.getItem('userSelectQuality')
      const param = this.makeStreamParam(contentInfo, quality)
      StreamingService.getStreamingData(param).then(({ data }) => {
        this.streamingInfo = data
        this.vodObject = new VodObject()
        this.vodObject.setVodData(this.getContentType(contentInfo), contentInfo, this.streamingInfo)
        if (Object.keys(this.streamingInfo.preview).length == 0) this.makePreviewData()
        if (this.isOnAirVod(contentInfo)) {
          // console.log('streaming status..')
          this.streamingStatus = ''
          StreamingService.getStreamingStatus({ 'type': 'onair', 'contentId': param.contentId }).then(({ data }) => {
            this.streamingStatus = data
          })
        }

        this.isAutoPlay = false
        if (this.$route.params.autoplay !== null && this.$route.params.autoplay === true) {
          this.isAutoPlay = true
        }
      }).catch((e) => {
        if (this.streamTimerId != null) {
          clearInterval(this.streamTimerId)
          this.streamTimerId = null
        }
      })
    },
    controlMoreInfo (command, flag) {
      switch (command) {
        case 'changeSnsPopupStatus':
          this.snsPopupStatus = flag;
          break;
        default:
      }
    },
    setVodPlayerUI (vodPlayerUI) {
      this.vodPlayerUI = vodPlayerUI
    },
    setAdvertisementUI (advertisementUI) {
      this.advertisementUI = advertisementUI
    },
    makePreviewData () {
      if (this.getCredential) {
        this.streamingInfo.preview = {
          'exitbtn': 'purchase,confirm',
          'exitmsg': '이용권 구매 후 시청해주세요.',
          'exittitle': '[미리보기 종료]',
          'previewbtn': 'purchase',
          'previewmsg': '[미리보기] 이용권 구매 후 시청해주세요.'
        }
      } else {
        this.streamingInfo.preview = {
          'exitbtn': 'login,join',
          'exitmsg': '로그인 또는 회원가입 후 시청하세요.',
          'exittitle': '[미리보기 종료]',
          'previewbtn': 'login,join',
          'previewmsg': '[미리보기] 로그인 또는 회원가입 후 시청하세요.'
        }
      }
    },
    setQualitySelect (qualitySelect) {
      this.qualitySelect = qualitySelect
    },
    vodPlay () {
      if (this.vodObject !== null) {
        if (this.vodObject.isDrm || (this.contentInfo.drms !== '' && this.contentInfo.drms !== null && this.contentInfo.drms !== undefined)) {
          alert('이 기기에서 재생할 수 없는 콘텐츠입니다.\n모바일, PC 등 다른 기기를 이용하여 시청하세요.')
          return // 여기서 종료
        } else if (this.streamingInfo.marketing != null && Object.keys(this.streamingInfo.marketing).length > 0) {
          this.vodObject.setPurchaseMsg(this.streamingInfo.marketing.marketingmsg)
          this.vodObject.setPurchaseBtns(this.streamingInfo.marketing.marketingbtn)
        } else if (this.getCredential && this.vodObject.isPreview) {
          this.vodObject.setPurchaseMsg('화질을 변경하시거나 이용권 구매 후 시청하세요.')
          this.vodObject.setPurchaseBtns('purchase,change')
          // this.qualitySelect.autoChangeQuality() // 문제가 있어 주석처리... 나중에 확인 필요
          // return
        }
        // vod 재생시 playId 쿠키에 저장
        utils.cookies.setItem('lastPlayId', this.streamingInfo.playid, null, URL_COOKIE_DOMAIN, '/')

        let vodObject = this.vodObject
        let vodPlayer = new VodPlayer('player')
        let vodPlayerUI = this.vodPlayerUI
        vodPlayerUI.reset()
        vodPlayer.addPlayer(document.getElementById('player'), null, '100', vodObject)
        vodPlayer.addEventHandler(VodPlayer.EVENT.ON_SOURCE_LOADED, () => {
          if (vodObject.isAd) {
            this.advertisementUI.onAdStarted()
            this.vodObject.sendAdLog('start')
          } else if (vodObject.isPreview === false) {
            // 미리보기가 아닌경우 이어보기
            //화질 변경시
            if (this.qualityChangedTime != null) {
              vodPlayer.seek(this.qualityChangedTime)
              this.qualityChangedTime = null
            }
            else if(parseInt(this.contentInfo.viewtime) > 0) {
                vodPlayer.seek(this.contentInfo.viewtime)
                this.$toast({ message: MSG_PLAYVOD_CONTINUED })
            }
          } else {
            console.log('isPreview.....')
            if (this.qualityChangedTime != null) {
              vodPlayer.seek(this.qualityChangedTime)
              this.qualityChangedTime = null
            }
            this.sortVodLayer();
          }
        }, false)
        vodPlayer.addEventHandler(VodPlayer.EVENT.ON_TIME_CHANGED, () => {
          if (vodObject.isAd) {
            vodPlayerUI.setTime(vodPlayer.getCurrentTime())
            let quarter = vodObject.getAdDuration() / 4
            let playedTime = Math.floor(vodPlayer.getCurrentTime() % 3600 % 60)
            if ((playedTime / quarter) > 1 && vodObject.adLogStep === 'start') {
              vodObject.sendAdLog('quarter1')
            } else if ((playedTime / quarter) > 2 && vodObject.adLogStep === 'quarter1') {
              vodObject.sendAdLog('quarter2')
            } else if ((playedTime / quarter) > 3 && vodObject.adLogStep === 'quarter2') {
              vodObject.sendAdLog('quarter3')
            }
          } else if (vodObject.type === 'live') {
            if (this.isRadioChannel()) { //라디오 채널인 경우
              vodPlayerUI.updateLivePlay()
            } else if (vodObject.isPreview || this.getCredential === false) {
              if (this.livePlayStartTime != null && (new Date() - this.livePlayStartTime) > this.vodObject.totalPlayTime * 1000) {
                this.vodPlayer.pause()
                this.vodPlayer.onCompleted()
              } else {
                if (this.livePlayStartTime == null) this.livePlayStartTime = new Date()
                vodPlayerUI.updateLivePlay()
              }
            } else vodPlayerUI.updateLivePlay()
          } else vodPlayerUI.setTime(vodPlayer.getCurrentTime())
        }, false)
        vodPlayer.addEventHandler(VodPlayer.EVENT.ON_PAUSED, () => {
          if (vodObject.isAd) this.advertisementUI.onPaused()
          vodPlayerUI.isPlaying = vodPlayer.playing
          this.clearBookmarkTimer()
        }, false)
        vodPlayer.addEventHandler(VodPlayer.EVENT.ON_ERROR, () => {
        	this.vodPlay()
          setTimeout(function(){
            this.vodPlayer.pause()
          }.bind(this),1000)
        },false)
        vodPlayer.addEventHandler(VodPlayer.EVENT.ON_PLAY, () => {
          if (vodObject.isAd) this.advertisementUI.onResumed()
          vodPlayerUI.isPlaying = vodPlayer.playing
         // if (vodObject.isPreview === false && vodObject.type !== 'live' && vodObject.isAd == false) {
            if (vodObject.isPreview === false && vodObject.isAd == false) {
            // 미리보기가 아닌경우
            // 북마크 10초마다 전송
            this.startBookmarkTimer()
          }
        }, false)
        vodPlayer.addEventHandler(VodPlayer.EVENT.ON_PLAYBACK_FINISHED, () => {
          if (vodObject.isAd) {
            this.vodObject.sendAdLog('complete')
            this.changeAd()
          } else if (vodObject.isPreview === true) {
            // 미리보기 완료
            if (utils.cookies.getCredential() === 'none') {
              // 로그인 안함
              this.isShowPlayEndGuide = true
              this.isShowPlayEndPlayList = false
              this.playEndPlayListStatus = ''
              this.isShowPlayEndRecommend = false
            } else {
              // 이용권 없음
              this.isShowPlayEndGuide = true
              this.isShowPlayEndPlayList = false
              this.playEndPlayListStatus = ''
              this.isShowPlayEndRecommend = false
            }
          } else {
            // 일반 보기 완료
            this.isShowPlayEndGuide = false
            const section = this.currentSection.toUpperCase()
            if (section === 'VOD') {
              this.playEndPlayListStatus = ''
              console.log(this.contentInfo.prevepisode)
              console.log(this.contentInfo.prevepisode.contentid)
              if ((this.contentInfo.prevepisode !== null && this.contentInfo.prevepisode.contentid !== '') && (this.contentInfo.nextepisode !== null && this.contentInfo.nextepisode.contentid !== '')) {
                this.playEndPlayListStatus = 'all'
                this.isShowPlayEndPlayList = true
              } else if ((this.contentInfo.prevepisode === null || this.contentInfo.prevepisode.contentid === '') && (this.contentInfo.nextepisode !== null && this.contentInfo.nextepisode.contentid !== '')) {
                this.playEndPlayListStatus = 'next'
                this.isShowPlayEndPlayList = true
              } else {
                this.isShowPlayEndPlayList = false
                this.playEndPlayListStatus = ''
                this.isShowPlayEndRecommend = true
              }
              // else if ((this.contentInfo.prevepisode !== null && this.contentInfo.prevepisode.contentid !== '') && (this.contentInfo.nextepisode === null || this.contentInfo.nextepisode.contentid === '')) {
              // 이전회차라도 나와야하면 수정할 필요 있음
              //   this.playEndPlayListStatus = 'prev'
              //   this.isShowPlayEndPlayList = true
              // }
            } else {
              this.isShowPlayEndPlayList = false
              this.playEndPlayListStatus = ''
              this.isShowPlayEndRecommend = true
            }
          }
          console.log(this.isShowPlayEndRecommend)
        }, false)
        this.vodPlayer = vodPlayer
        this.isVodPlaying = true
        this.clickCont()
      }
    },
    changeAd () {
      this.vodObject.changeAd()
      this.vodPlayer.destroy()
      this.vodPlay()
    },
    getProgramId () {
      let programId = ''

      if (this.currentSection === 'live') {
        programId = this.contentInfo.channelid
      } else if (this.currentSection === 'movie') {
        programId = 'MOVIE'
      } else {
        programId = this.contentInfo.programid
      }

      return programId
    },
    sendBookmark () {
      let programId = this.getProgramId()
      let contentId = null
      let channelType = null

      if (this.currentSection === 'live') {
        contentId = ''
        channelType = 'L'
      } else if (this.currentSection === 'movie') {
        contentId = this.contentInfo.movieid
        channelType = 'M'
      } else {
        contentId = this.contentInfo.contentid
        channelType = 'V'
      }

      let itemType = null
      let br = null
      switch (this.streamingInfo.quality) {
        case '480p':
          itemType = '3'
          br = '1000'
          break
        case '720p':
          itemType = '4'
          br = '2000'
          break
        case '1080p':
          itemType = '9'
          br = '5000'
          break
        default:
      }

      let valExtra = {
        'osV': utils.getOSInfoStr(),
        'appV': GNB.version,
        'apiV': '3',
        'networkType': '0',
        'carrier': 'none',
        'mcc': 'none',
        'mnc': 'none'
      }

      let tmpObj = this.streamingInfo.bookmarkextra
      for(var key in tmpObj){
        valExtra[key] = tmpObj[key];
      }

      const cs = JSON.parse(utils.cookies.getItem('cs'))

      StreamingService.sendBookMark({
        'userNo': utils.cookies.getUno(),
        'programId': programId,
        'contentId': contentId,
        'corderId': '1',
        'channelType': channelType,
        'itemType': itemType,
        'deviceType': '31', //  mobile : 1 , familyhub : 31
        'logDate': utils.getTimeStamp(),
        'logType': 'I',
        'mediaTime': utils.convertSecondToPlayTime(parseInt(this.vodPlayer.getCurrentTime()), true), // 00:00:00 시:분:초
        'ipAddress': utils.cookies.getItem('for_wavve_ip'),
        'concurrencyGroup': this.streamingInfo.concurrencygroup,
        'issue': this.streamingInfo.issue,
        'playId': this.streamingInfo.playid,
        'guid': utils.guid,
        'isABR': this.vodObject.isAbr,
        'BR': br,
        'isCharged': this.streamingInfo.chargedtype,
        'priceType': this.streamingInfo.pricetype,
        'pooqzoneType': utils.cookies.getPooqZoneType(),
        'profileId': cs == null ? '' : cs.profile,
        'extra': valExtra
      },function(error){
        StreamingService.sendBookmarkError({
        'userNo': utils.cookies.getUno(),
        'programId': programId,
        'contentId': contentId,
        'corderId': '1',
        'channelType': channelType,
        'itemType': itemType,
        'deviceType': '31', //  mobile : 1 , familyhub : 31
        'logDate': utils.getTimeStamp(),
        'logType': 'E',
        'mediaTime': utils.convertSecondToPlayTime(parseInt(this.vodPlayer.getCurrentTime()), true), // 00:00:00 시:분:초
        'ipAddress': utils.cookies.getItem('for_wavve_ip'),
        'concurrencyGroup': this.streamingInfo.concurrencygroup,
        'issue': this.streamingInfo.issue,
        'playId': this.streamingInfo.playid,
        'guid': utils.guid,
        'isABR': this.vodObject.isAbr,
        'BR': br,
        'isCharged': this.streamingInfo.chargedtype,
        'priceType': this.streamingInfo.pricetype,
        'pooqzoneType': utils.cookies.getPooqZoneType(),
        'profileId': cs == null ? '' : cs.profile,
        'extra': valExtra
        })
      })
    },
    startBookmarkTimer () {
      this.clearBookmarkTimer()
      this.bookmarkTimerId = setInterval(() => {
        this.sendBookmark()
      }, 10000)
    },
    clearBookmarkTimer () {
      if (this.bookmarkTimerId != null) clearInterval(this.bookmarkTimerId)
    },
    startUITimer () {
      this.clearUITimer()
      this.uiTimerId = setTimeout(() => {
        this.isShowVodControl = false
        this.uiTimerId = null
      }, 5000)
    },
    clearUITimer () {
      if (this.uiTimerId != null) clearTimeout(this.uiTimerId)
    },
    openSetting () {
      this.vodPlayer.pause()
      this.isOpenSetting = true
      disableBodyScroll()
    },
    closeSetting (isReset) {
      this.isOpenSetting = false
      if (isReset === true && this.vodPlayer != null) {
        this.vodPlayer.destroy()
        this.vodPlay()
      }
      else this.vodPlayer.play()
      enableBodyScroll()
      this.sortVodLayer()
    },
    sortVodLayer (){
      if(this.streamingInfo.quality === "100p"){
        document.getElementById('vplayer').style.zIndex = -1;
      }else{
        document.getElementById('vplayer').style.zIndex = 0;
      }
    },
    changeQuality (quality) {
      const contentInfo = this.contentInfo
      if(this.currentSection !== 'live') this.qualityChangedTime = this.vodPlayer.getCurrentTime()
      StreamingService.getStreamingData(this.makeStreamParam(contentInfo, quality)).then(({ data }) => {
        this.streamingInfo = data
        this.vodObject.setVodData(this.getContentType(contentInfo), contentInfo, this.streamingInfo)
        if (Object.keys(this.streamingInfo.preview).length == 0) this.makePreviewData()
        if (this.streamingInfo.marketing != null && Object.keys(this.streamingInfo.marketing).length > 0) {
          this.vodObject.setPurchaseMsg(this.streamingInfo.marketing.marketingmsg)
          this.vodObject.setPurchaseBtns(this.streamingInfo.marketing.marketingbtn)
        } else if (this.getCredential && this.vodObject.isPreview) {
          this.vodObject.setPurchaseMsg('화질을 변경하시거나 이용권 구매 후 시청하세요.')
          this.vodObject.setPurchaseBtns('purchase,change')
          // this.qualitySelect.autoChangeQuality() // 문제가 있어 주석처리... 나중에 확인 필요
          // 위 코드가 활성화 되면 삭제
        } else {
          // if (this.isOnAirVod(contentInfo)) {
          //   StreamingService.getStreamingStatus({ 'type': 'onair', 'contentId': id }).then(({ data }) => {
          //     this.streamingStatus = data
          //   })
          // } // 필요한지 확인필요
        }
        this.closeSetting(true)
      }).catch(e => {
        // 실패케이스....
      })
    },
    goBottomRecommendTab () {
      window.scrollTo(0, 600)
      EventBus.$emit('go-recommend')
    },
    isRadioChannel () {
      return this.currentSection === 'live' && this.contentInfo.type === 'audio'
    },
    goEventPage (event) {
      this.$router.push(`/event/detail/${event.eventid}`)
    },
    EventToggle (index) {
      return this.eventIndexArr.indexOf(index) > -1
    },
    closePlayEndGuidePopup () {
      this.isShowPlayEndGuide = false
      return this.isShowPlayEndGuide
    },
    exitPlayEndPlayListPopup (selectMenu) {
      console.log('exitPlayEndPlayListPopup selectMenu : ', selectMenu)
      if (selectMenu === 'prev' && this.contentInfo.prevepisode !== null && this.contentInfo.prevepisode.contentid !== '') {
        this.goPlayer(this.contentInfo.prevepisode.contentid)
        this.playEndPlayListStatus = ''
        this.isShowPlayEndPlayList = false
      } else if (selectMenu === 'next' && this.contentInfo.nextepisode !== null && this.contentInfo.nextepisode.contentid !== '') {
        this.goPlayer(this.contentInfo.nextepisode.contentid)
        this.playEndPlayListStatus = ''
        this.isShowPlayEndPlayList = false
      } else if (selectMenu === 'replay') {
        this.vodPlayer.play()
        this.playEndPlayListStatus = ''
        this.isShowPlayEndPlayList = false
      }
      return this.isShowPlayEndPlayList
    },
    goPlayer (contentid) {
      this.$router.push({
        name: 'player',
        params: {
          section: 'vod',
          autoplay: true
        },
        query: { contentid: contentid }
      }, function () {
        console.log('complete')
      })
    },
    closePlayEndRecommendPopup () {
      this.isShowPlayEndRecommend = false
      return this.isShowPlayEndRecommend
    }
  },
  computed: {
    ...mapGetters(['getBeforeEnterPlayerPath', 'isVisibleAdultCheckView']),
    getToggleButton () {
      let buttonName = ''
      if (!this.detailInfoToggleState) {
        buttonName = 'open-info-button'
      } else if (this.detailInfoToggleState) {
        buttonName = 'close-info-button'
      }
      return buttonName
    },
    playerDetailComponent () {
      return this.currentSection ? `${this.currentSection}-player-detail-info` : null
    },
    descInfoMoreComponent () {
      if (this.currentSection !== 'live') { return `${this.currentSection}-desc-info-more` } else return null
    },
    getConvertedTagList () {
      const tagCount = get(this.contentInfo, ['tags', 'count'], '')
      if (tagCount === '' || tagCount === '0') return []
      let tagList = get(this.contentInfo, ['tags', 'list'], []).map((tag) => {
        if (typeof tag === 'string') {
          return {
            text: tag,
            value: tag,
            taggroup: 'tag'
          }
        } else {
          if (tag.taggroup === undefined) {
            tag.taggroup = 'tag'
          }
          return tag
        }
      })
      tagList = tagList.filter((tag) => { return tag.text !== '' })
      return tagList
    },
    getCredential () {
      return utils.cookies.getCredential() !== 'none'
    }
  },
  created () {
    this.currentSection = this.$route.params.section
    // INFO: 추천 목록에서 다른 회차나 프로그램이 19금일경우에 뒤로가기하면 그대로 남아 있는 경우가 있어서 create할때 vuex에 값이 있으면 초기화 한다.
    if (this.isVisibleAdultCheckView) {
      this.hideAdultCheck()
    }
    if (get(this.$route, ['query', 'search'], 'n').toLowerCase() === 'y') {
      this.zIndex = 3001
    }
    this.loadContent(this.$route)
  },
  mounted () {
    enableBodyScroll()
  },
  updated () {
    this.$nextTick(function () {
      let interval = setInterval(function () {
        const player = document.getElementById('player')
        if (!player) return
        const boundingRect = player.getBoundingClientRect()
        player.style.maxHeight = boundingRect.height
        clearInterval(interval)
      }, 50)

      if (this.isAutoPlay) {
        // console.log('autoPlay...')
        this.isAutoPlay = false
        if (this.vodObject.isReady) this.vodPlay()
        else {
          this.streamTimerId = setInterval(() => {
            if (this.vodObject != null && this.vodObject.isReady) {
              this.vodPlay()
              clearInterval(this.streamTimerId)
              this.streamTimerId = null
            }
          }, 200);
        }
      }
    })
  },
  beforeRouteLeave (to, from, next) {
    if (this.isVisibleAdultCheckView) {
      this.hideAdultCheck()
    }
    next()
  },
  watch: {
    $route (to, from) {
      this.currentSection = get(to, ['params', 'section'], '')
      this.loadContent(to)
    }
  },
  destroyed () {
    this.clearBookmarkTimer()
    EventBus.$off('go-recommend')
  }
}
</script>

<style scoped>
  header {
    width: 100%;
  }
  .play-container {
    position: relative;
    background-color: #1b1b1b;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .play-container.chrome-fixed{
    position: fixed;
    height: 100vh;
    overflow: hidden;
  }
  .player {
    position: relative;
    width: 100%;
    background-color: black;
    top: 0;
    left: 0;
    padding-top: 56.25%;
    max-height: 210px;
  }
  .player-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%
  }

  .player-image.movie {
    position: absolute;
    top: 0;
    left: 0;
    width: auto;
    height: 100%;
    margin-left: 30.4%;
  }
  .player-back-btn {
    position: absolute;
    left: 15px;
    top: 15px;
    width: 36px;
    height: 36px;
    z-index: 100;
  }
  .play-event-container {
    position: relative;
    width: 100%;
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 18px;
    color: #a5a5a5;
    border: 1px solid #2f2f2f;
  }
  .play-event-container .tag-event{
    display: inline-block;
    color: #1da8ee;
    border: solid 1px #1da8ee;
    border-radius: 13px;
  }
  .play-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 36px;
    height: 36px;
    margin-left: -18px;
    margin-top: -18px;
  }
  .event-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    width: 100%;
    padding: 20px;
  }
  .event-header .tag,
  .event-header .title{
    display: inline-block;
    vertical-align: middle;
    position: relative;
  }
  .event-header .tag{
    width: 45px;
    margin-right: 10px;
    font-size: 10px;
    text-align: center;
  }
  .event-header .title{
    flex: 1;
  }
  .event-header .icon-btn{
    display: inline-block;
    width: 12px;
  }
  .event-header .icon-btn svg{
    display: block;
  }
  .event-body {
    position: relative;
    padding: 20px;
  }
  .gift,
  .event-box,
  .event-link{
    display: block;
  }
  .gift,
  .event-box{
    margin-bottom: 10px
  }
  .event-date-txt{
    display: inline-block;
    width: 92px;
  }
  .event-link{
    margin-top: 20px;
    color: #fff
  }
  .event-link span,
  .event-link svg{
    display: inline-block;
    vertical-align: middle;
  }
  @media screen and (min-width: 768px){
    .player{
      position: sticky;
      top: 0;
      z-index: 0;
    }
  }
  div.audio {
    position: absolute;
    top: 32%;
    left: 34%;
    width: 190px;
    height: 30px;
    line-height: 30px;
    border-radius: 14px;
    text-align: center;
    vertical-align: middle;
    color: #fff;
    background: #777777;
    font-size: 15px;
    opacity: 0.8;
  }
  div.audio img {
    position: relative;
    top: -3px;
    left: -6px;
  }
</style>
